import axios from 'axios';

const rawBaseUrl = process.env.REACT_APP_API_URL || '';

// Evita URLs com barra dupla quando a variável de ambiente termina em "/".
export const API_URL = rawBaseUrl.replace(/\/+$/, '');

const api = axios.create({
  baseURL: API_URL,
});

let authToken = null;
let onUnauthorized = null;

export const setAuthToken = (token) => {
  authToken = token || null;
};

/** Registra o que fazer quando a API recusar o token da sessão. */
export const setUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

/**
 * A API responde 401 "Não autorizado" quando o recurso é de outro usuário e
 * 400 "Token inválido" quando o token expirou. Só o segundo caso (e a falta
 * de token) deve encerrar a sessão — por isso a checagem olha a mensagem.
 */
const isSessionFailure = (error) => {
  const status = error?.response?.status;
  const message = error?.response?.data?.msg || '';

  if (status === 401) {
    return /token/i.test(message);
  }

  if (status === 400) {
    return /token inv[áa]lido|token mal formatado/i.test(message);
  }

  return false;
};

api.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (onUnauthorized && isSessionFailure(error)) {
      onUnauthorized();
    }

    return Promise.reject(error);
  }
);

/** Extrai uma mensagem legível de qualquer formato de erro da API. */
export const getErrorMessage = (error, fallback = 'Algo deu errado. Tente novamente.') => {
  const data = error?.response?.data;

  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  if (data?.msg) {
    return data.msg;
  }

  if (error?.code === 'ERR_NETWORK') {
    return 'Sem conexão com o servidor. Verifique sua internet.';
  }

  return fallback;
};

export default api;
